import { connect } from 'react-redux';

import CopyApiKeyField from '../components/CopyApiKeyField';

const _mapStateToProps = ({ apiKeyState }) => ({
    apiKey: apiKeyState.apiKey,
});

export default connect(_mapStateToProps)(CopyApiKeyField);
